import { cloneDeep } from "lodash-es";
import { ResultRow } from "../data-structures/results/result-row.model";
import { FinancialResults, FinancialResultsInterface } from "./financial/financial.model";
import { TechnicalResults, TechnicalResultsInterface } from "./technical/technical-results.model";
import { Alert } from "../helper/alerts-menu.model";

export interface ResultsInterface {
  resultErrors?: any;
 'RESULTS.DATA.TECHNICAL.TITLE'?: TechnicalResultsInterface;
 'RESULTS.DATA.FINANCIAL'?: FinancialResultsInterface;
 'RESULTS.DATA.CREATED'?: string | null;
 'RESULTS.DATA.ERRORS'?: Record<string, Alert>;
}
export class Results {
  resultErrors: any;
  'RESULTS.DATA.TECHNICAL.TITLE': TechnicalResults;
  'RESULTS.DATA.FINANCIAL': FinancialResults;
  'RESULTS.DATA.CREATED';
  'RESULTS.DATA.ERRORS'?: Record<string, Alert>;;
  get technical() {
    return this['RESULTS.DATA.TECHNICAL.TITLE'];
  }
  set technical(value: TechnicalResults) {
    this['RESULTS.DATA.TECHNICAL.TITLE'] = value;
  }
  get created(): string | null {
    return this['RESULTS.DATA.CREATED'];
  }
  set created(value: string) {
    this['RESULTS.DATA.CREATED'] = value;
  }
  get financial() {
    return this['RESULTS.DATA.FINANCIAL'];
  }
  set financial(value: FinancialResults) {
    this['RESULTS.DATA.FINANCIAL'] = value;
  }

  constructor(param: ResultsInterface = {}) {
    if (param.resultErrors) {
      this.resultErrors = param.resultErrors;
    }
    this['RESULTS.DATA.TECHNICAL.TITLE'] = param['RESULTS.DATA.TECHNICAL.TITLE']
      ? new TechnicalResults(param['RESULTS.DATA.TECHNICAL.TITLE'])
      : new TechnicalResults()

    this['RESULTS.DATA.CREATED'] = param['RESULTS.DATA.CREATED'] ?? null;

    this['RESULTS.DATA.FINANCIAL'] = param['RESULTS.DATA.FINANCIAL']
      ? new FinancialResults(param['RESULTS.DATA.FINANCIAL'])
      : new FinancialResults()

    if (param["RESULTS.DATA.ERRORS"]) {
      this["RESULTS.DATA.ERRORS"] = param["RESULTS.DATA.ERRORS"];
    }
  }

  deepCopy() {
    return cloneDeep(new Results(this));
  }

  static getValueFromTechResult(row: ResultRow): number {
    if (row && row.values !== null && row.values[0] !== null) {
      return row.values[0];
    }
  }
}


